import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '../../../translation.esm.js';

const GerritRepoPicker = (props) => {
  const { onChange, rawErrors, state } = props;
  const { t } = useTranslationRef(scaffolderTranslationRef);
  const { workspace, owner } = state;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormControl, { margin: "normal", error: rawErrors?.length > 0 && !workspace }, /* @__PURE__ */ React.createElement(
    TextField,
    {
      id: "ownerInput",
      label: t("fields.gerritRepoPicker.owner.title"),
      onChange: (e) => onChange({ owner: e.target.value }),
      helperText: t("fields.gerritRepoPicker.owner.description"),
      value: owner
    }
  )), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      margin: "normal",
      required: true,
      error: rawErrors?.length > 0 && !workspace
    },
    /* @__PURE__ */ React.createElement(
      TextField,
      {
        id: "parentInput",
        label: t("fields.gerritRepoPicker.parent.title"),
        onChange: (e) => onChange({ workspace: e.target.value }),
        value: workspace,
        helperText: t("fields.gerritRepoPicker.parent.description")
      }
    )
  ));
};

export { GerritRepoPicker };
//# sourceMappingURL=GerritRepoPicker.esm.js.map
